<template>
  <InterfaceCard
      color="red"
      icon="mdi-alert-circle"
      title="Доступ ограничен"
  >
    <v-list
        class="with-white-spaces"
        :dense="$vuetify.breakpoint.mobile"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="red--text">Подписка ЛК истекла</v-list-item-title>
          <v-list-item-subtitle class="red--text">
            Сообщите об этом вашему организатору, чтобы он продлил подписку и вы сможете продолжить работу в ЛК
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </InterfaceCard>
</template>

<script>
import InterfaceCard from '@/components/InterfaceCard'
export default {
  name: 'ErrorNeedPay',
  components: {InterfaceCard}
}
</script>

<style scoped>

</style>
